export const gtag: Gtag.Gtag = function () {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(arguments)
}
